import axios from 'axios'
import firebaseConfig from 'configs/FirebaseConfig'
import { getAuth } from 'firebase/auth'
import { isFunctionsEmulatorEnabled, getEmulatorHostPort } from 'utils/functionsEmulator'
const getToken = async () => {
  if (getAuth() && getAuth().currentUser) {
    return (await getAuth().currentUser.getIdTokenResult()).token
  } else {
    return null
  }
}

let baseURL = `https://${process.env.REACT_APP_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/`
if (isFunctionsEmulatorEnabled()) {
  const { host, port } = getEmulatorHostPort()
  baseURL = `http://${host}:${port}/${firebaseConfig.projectId}/${process.env.REACT_APP_REGION}/`
  console.info('Using Firebase Functions Emulator at ' + baseURL)
}
const instance = axios.create({
  baseURL: baseURL,
})

// Add a request interceptor
instance.interceptors.request.use(
  async (config) => {
    const token = await getToken()
    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `Bearer ${token}`,
        tenantId: getAuth().currentUser.uid,
        'Content-Type': 'application/json',
      }
    }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export default instance
